import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { InsightSection } from './components/InsightSection';
import { FailedAttemptsSection } from './components/FailedAttemptsSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-white font-sans text-stone-900 antialiased selection:bg-orange-200 selection:text-orange-900" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <InsightSection data-id="element-3" />
      <FailedAttemptsSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <DeliverablesSection data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <ObjectionsSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <Footer data-id="element-11" />
    </main>;
}